module.exports = __webpack_public_path__ + "static/media/banner_strail.9c76e516.svg";